// Components
import DatePicker from 'vue2-datepicker';
const ModalDisapproveCancellationRequest = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-disapprove-cancellation-request"*/ '@/app/views/main-view/dog-orders/containers/modals/modal-disapprove-cancellation-request/modal-disapprove-cancellation-request.vue');

// Mixins
import { dateMixins } from '@/app/mixins/utils/date-mixins';
import { productMixins } from '@/app/mixins/modules/product-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js';
import { numberFormatMixins } from '@/app/mixins/modules/number-format-mixins';
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';

// Services
import BreedService from '@/app/services/main/breeds/breeds-service';
import ProductService from '@/app/services/main/product/product-service';
import OrdersService from '@/app/services/main/orders/orders-service';

// Constants
import { STATUS_CODES, DOG_ORDER_STATUS } from '@/app/constants/constants';

export default {
	name: 'OrdersDetailsContainer',
	template: '#timeline-item-template',
	components: {
		DatePicker,
		ModalDisapproveCancellationRequest
	},
	mixins: [
		productMixins,
		toastMessageMixins,
		numberFormatMixins,
		inputTextMixins,
		dateMixins
	],
	data() {
		return {
			isEditAPILoading : false,
			breederRowId:'',
			petDetailsId:'',
			petOrder:'',
			// container
			productEditDetails: null,
			// fields
			userId:'',
			customer:'',
			productName: '',
			requested:false,
			pendingStatus:false,
			forApproval:false,
			price: '0.00',
			selectTypeIsBreed: true,
			breederId:'',
			breederName:'',
			breederMobile :'',
			mobileNumberIsValid: true,
			breedId:'',
			birthDate:'',
			gender:'',
			colour:'',
			size:'',
			weight:'',
			notes:'',
			isBreedsAPILoading: false,
			breedList:[],
			genderList: [{name: 'Male', value: 'M'}, {name: 'Female', value: 'F'}],
			sizeList: [
				{
					id: 1,
					name: 'Toy'
				},
				{
					id: 2,
					name: 'Small'
				},
				{
					id: 3,
					name: 'Medium'
				},
				{
					id: 4,
					name: 'Large'
				},
				{
					id: 5,
					name: 'Extra Large'
				}
			],
			orderDetails: {fullName:'', address:''},
			storeCredit: 0,
			dogInfo: {

			},
			items: [],
			isActionAPILoading:false
		}
	},
	created() {
		this.getBreedList();
		this.setFieldsForUpdate();
	},
	computed: {
		timelineList() {
			return this.items.reverse();
		}
	},
	methods: {
		async getBreedList() {
			this.isBreedsAPILoading = true;
			const res = await BreedService.getBreeds();

			if (res.status === STATUS_CODES.SUCCESS) {
				this.breedList = res.data.data;

				
			} 

			this.isBreedsAPILoading = false;
		},
		setFieldsForUpdate() {
			if (this.$route.params && this.$route.params.orderId) {
				OrdersService.getOrderById(this.$route.params.orderId)
					.then(res => {
						if (res.status === STATUS_CODES.SUCCESS) {
							this.orderDetails = res.data;

							this.petHistory(res.data.transactionPetOrderHistory);
							
							this.orderHistory(res.data.transactionHistory);

							this.getDogInfo(res.data.bundles[0].products);
						} else {
							this.showAPIErrorToast('Unable to get order data.', res);
						}
							this.isAPILoading = false;
					})
					.catch(() => {
						this.showGenericErrorToast();
						this.isAPILoading = false;
					});
			}
		},

		petHistory(history) {
			if (history) {
				for (const data of history) {
					const {date, status} = data;
					
					let transDate = this.formatDateTime(date);

					this.items.push({
						content: `[${transDate}] : ${DOG_ORDER_STATUS[status]}`
					});
				}
			}
		},
		orderHistory(history) {
			if (history) {
				for (const data of history) {
					const {date, status} = data;
					
					let transDate = this.formatDateTime(date);
					let content  = DOG_ORDER_STATUS[status];
					if(status === 'For cancellation'){
						content += `<br> (Reason: ${this.orderDetails.reason})`
					}	
					this.items.push({
						htmlMode: true,
						content: `[${transDate}] : ${content}`
					});
				}
			}
		},

		getDogInfo(info) {
			for (const data of info) {
				if(data.productTypeId === 7){
					this.storeCredit = data.priceAtOrder;
					
				}else{
					this.price = data.priceAtOrder;
					ProductService.getProductDogById(data.id)
						.then(res => {
							if (res.status === STATUS_CODES.SUCCESS) {
								const {
									birthdate,
									breederId,
									breederName,
									colour,
									gender,
									size,
									breedId,
									breederMobile,
									name
									} = res.data;

									//mobile number formatting
									let tempMobile = '';

									if (breederMobile) {
									tempMobile = breederMobile.split('');
									tempMobile.splice(4, 0, '-');	
									}
									this.productName = name;
									this.birthDate = this.formatDate(new Date(birthdate));
									this.breederId = breederId;
									this.breederName = breederName;
									this.size = {name: size};
									this.gender = gender === 'M' ? {name: 'Male', value: 'M'} :{name: 'Female', value: 'F'};
									this.colour = colour;
									this.breedId = breedId;
									this.breederMobile = tempMobile.join('');
									
									let breedData =  this.breedList.filter(breed => { 
										return breed.id === this.breedId;
									});
							
									this.breedId = breedData[0];

									this.isEditAPILoading = false;
								} else {
									this.isEditAPILoading = false;
									this.showAPIErrorToast(this.toastMessages.product().ERROR_PRODUCT_FETCH, res);
								}
						});
				}
			}
		},

		goBack() {
			this.$router.go(-1);
		},
		showDisapproveModal() {
		this.$refs.modalDisapprove.openModal(this.orderDetails);
			
		},
		submitApproval() {
			this.isActionAPILoading = true;

			OrdersService.putApproveRefund(this.orderDetails.id)
				.then(res => {
					const { SUCCESS_APPROVE_CANCELLATION, ERROR_APPROVE_CANCELLATION } = this.toastMessages.order();

					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.showCustomSuccessToast(SUCCESS_APPROVE_CANCELLATION, '');
						this.setFieldsForUpdate();
					} else {
						this.showAPIErrorToast(ERROR_APPROVE_CANCELLATION, res);
					}

					this.isActionAPILoading = false;
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isActionAPILoading = false;
				});
		},
	},
	// third party libraries
	validations() {
		return this.validationRules;
	}
}
